import React from "react";
import UserHeader from "./UserHeader";

interface MainLayoutProps {
  children: React.ReactNode;
}

/**
 * MainLayout - Standard Layout für normale Browser-Ansichten
 *
 * Bietet einheitlichen Wrapper für alle nicht-Kiosk Views
 * mit optionalem Logout-Button wenn Auth aktiviert ist
 */
const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <UserHeader />
      <main className="p-2 sm:p-6">{children}</main>
    </div>
  );
};

export default MainLayout;
